import { IRecipient } from '../../../../../../surveys/models/Api';

export interface ITicketHolder {
	id?: string; // Unique ID from backend or generated UUID
	ticketId: string;
	ticketName: string; // For display (e.g., "Basic Ticket")
	firstName: string;
	lastName: string;
	email: string;
	phone: string;
	isPaid?: boolean; // Whether this ticket has been paid for
}

export interface IFormValues {
	isAttending: boolean | null;
	isPaid: boolean;
	bringingGuest?: boolean;
	email?: string;
	firstName?: string;
	lastName?: string;
	phone?: string;
	guests: IRecipient[];
	customProperties: Record<string, string>;
	ticketSelections?: Record<string, number>; // ticketId → quantity
	ticketHolders?: ITicketHolder[]; // One entry per ticket purchased
}

export const DEFAULT_VALUES: IFormValues = {
	isAttending: null,
	isPaid: false,
	bringingGuest: false,
	email: '',
	guests: [{ firstName: '', lastName: '', isPaid: false }],
	firstName: '',
	lastName: '',
	phone: '',
	customProperties: {},
	ticketSelections: {},
	ticketHolders: [],
};
